<template>
	<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<Row :gutter="10" style="margin-bottom: 20px">
			<div class="yl-flex flex_between">
				<Form :label-width="80">
					<FormItem label="时间">
						<RadioGroup v-model="timeType">
							<Radio label="1" border><span>近3个月</span></Radio>
							<Radio label="2" border><span>近半年</span></Radio>
							<Radio label="3" border><span>近一年</span></Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="条件">
						<el-select v-model="city" style="width: 100px;margin-left: 10px;width: 150px;"
							placeholder="请选择城市">
							<el-option v-for="item in cityList" :value="item.city" :key="item.city">
								{{ item.city}}
							</el-option>
						</el-select>
						<el-select v-model="cid_type" style="width: 100px;margin-left: 10px;width: 150px;"  placeholder="请选择投放类型">
							<el-option v-for="item in cidTypeList" :key="item.id" :label="item.type" :value="item.id">
							</el-option>
						</el-select>
						<el-Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</el-Button>
					</FormItem>
				</Form>
			</div>
		</Row>
		<Table border :columns="columns" :data="datas">

		</Table>
	</div>
</template>

<script>
	import {
		getCidTypeList,
		getAdvHistoryDataList
	} from "../../../api/advManage.js";
	import {
		getAdvCity,
	} from "../../../api/runSet";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "adidData",
		components: {

		},
		props: ['timePeriod', 'timePeriodDate'],
		data() {
			return {
				cidTypeList:[],
				cityList:[],
				cid_type:'',
				city:'',
				timeType:'1',
				columns: [{
						"title": "月份",
						"key": "month",
						"align": 'center',
						"width": "100px"
					},
					{
						"title": "媒体渠道",
						"key": "username",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "系统转化数量",
						"key": "num",
						"align": 'center',
					},
					{
						"title": "媒体转化数量",
						"key": "account_convert",
						"align": 'center',
					},
					{
						"title": "2星+",
						"key": "twoplusname",
						"align": 'center',
					},
					{
						"title": "3星+",
						"key": "threeplus",
						"align": 'center',
					},
					{
						"title": "平均成本",
						"key": "avg_cost",
						"align": 'center',
					},
				],
				datas: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			sucaiID() {
				this.getList();
			},
			timePeriod() {
				this.getList();
			},
		},
		mounted() {
			this.loadData();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				this.getList();
			},
			mySearch() {
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.city = that.city;
				data.cid_type = that.cid_type;
				data.timeType = that.timeType;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				let res = await getAdvHistoryDataList(that, data);
				that.datas = res.data.list;
			},
		},
	};
</script>
<style lang="less" scoped>
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>